export default __webpack_public_path__ + "static/ndc-78be22c7c5c5baf98c3c971e9c2b1d27.png";